module.exports = __webpack_public_path__ + "static/results_mob_preview-4109b4e83c932e872234b3cce90e8ee5.png";